import { render } from "./DashboardHome.vue?vue&type=template&id=dc52ab26&scoped=true"
import script from "./DashboardHome.vue?vue&type=script&lang=js"
export * from "./DashboardHome.vue?vue&type=script&lang=js"

import "./DashboardHome.vue?vue&type=style&index=0&id=dc52ab26&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc52ab26"]])

export default __exports__